import { ActionType } from 'typesafe-actions'
import * as actions from './actions'

export type CmsAction =
  | ActionType<typeof actions.getCmsPDFRequest>
  | ActionType<typeof actions.getCmsPDFSuccess>
  | ActionType<typeof actions.getCmsPDFFail>

export interface CmsState {
  isFetchingCreate: boolean
  isFetching: boolean
  PDF: string
  error: boolean
}

export enum CmsActionTypes {
  GET_CMS_PDF_REQUEST = '@@auth/GET_CMS_PDF_REQUEST',
  GET_CMS_PDF_SUCCESS = '@@auth/GET_CMS_PDF_SUCCESS',
  GET_CMS_PDF_FAIL = '@@auth/GET_CMS_PDF_FAIL',
}
